import { useContext } from "react";
import { isNil } from "../utilities/isNil";
import { UnitSystemContext } from "../context/unitSystem";
export const useUnitSystemContext = () => {
    const context = useContext(UnitSystemContext);
    if (!context) {
        throw new Error("useUnitSystemContext must be used within a UnitSystemProvider");
    }
    if (isNil(context === null || context === void 0 ? void 0 : context.depthUnit) ||
        isNil(context === null || context === void 0 ? void 0 : context.speedUnit) ||
        isNil(context === null || context === void 0 ? void 0 : context.coordinatesFormat) ||
        isNil(context === null || context === void 0 ? void 0 : context.fuelUnit)) {
        const emptyUnits = [];
        Object.entries(context).forEach(([key, value]) => {
            if (isNil(value)) {
                emptyUnits.push(key);
            }
        });
        throw new Error(`units props found empty units - "${emptyUnits.join(", ")}}"`);
    }
    return context;
};
//# sourceMappingURL=useUnitSystem.js.map